/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditInApp/preview/styles.ts`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { colors, fonts, fontSizes, fontWeights, spacing } from 'ui/theme';

export const InAppContainerStyle = styled.div`
    align-items: stretch;
    background-color: ${colors.white};
    border: ${spacing.eighth} solid ${colors.grey25};
    border-radius: ${spacing.base};
    display: flex;
    flex-direction: column;
    margin: auto;
    overflow: hidden;
    position: relative;
    height: 600px;
    width: 320px;
    &[data-preview-view="web"] {
        width: 100%;
    }
    &[data-preview-view="inbox"] {
        align-items: flex-end;
        font-family: ${fonts.sfPro};
        padding: ${spacing.plusHalf} ${spacing.base} 0 ${spacing.base};
    }
`;

export const InboxHeader = styled.div`
    display: flex;
    font-size: ${fontSizes.s16};
    font-weight: ${fontWeights.bold};
    line-height: ${fontSizes.s24};
    margin-bottom: ${spacing.base};
    width: 100%; 
`;

export const InboxLine = styled.div`
    align-items: flex-start;
    border-bottom: ${spacing.single} solid ${colors.grey15};
    display: flex;
    padding: ${spacing.base} 0;
    justify-content: flex-start;
    width: 100%;
`;

export const InboxImage = styled.img`
    width: ${spacing.x4};
    height: ${spacing.x4};
    border-radius: ${spacing.half};
`;

export const InboxSubtitle = styled.div`
    align-items: flex-start;
    color: ${colors.grey90};
    display: flex;
    font-size: ${fontSizes.s11};
    font-weight: ${fontWeights.regular};
    line-height: ${fontSizes.s16};
    opacity: 75%;
`;

export const InboxText = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    margin-left: ${spacing.half};
`;

export const InboxTitle = styled.div`
    align-items: flex-start;
    color: ${colors.grey90};
    display: flex;
    font-size: ${fontSizes.s14};
    font-weight: ${fontWeights.bold};
    line-height: ${fontSizes.s16};
    flex: 1 1 auto;
`;

export const InboxSkeleton = styled.div`
  background-color: ${colors.grey5};
  border-radius: ${spacing.quarter};
`;
